import Swal from "sweetalert2";

/**
 * @see https://sweetalert2.github.io/#usage
 */
const SwAlert = ({
	title,
	text,
	footer,
	icon = "error" | "info" | "question" | "success" | "warning",
	iconHtml,
	imageIcon = "trash" | "success" | "error" | "warning" | "like",
	showCancelButton = false,
	cancelButtonColor = "#d33",
	cancelButtonText = "Não",
	onCancel,
	showConfirmButton = true,
	confirmButtonColor = "#FA6C12",
	confirmButtonText = "Sim",
	onConfirm,
	showCloseButton = false,
	timer,
	allowOutsideClick = true,
	allowEscapeKey = true,
	reverseButtons = false,
	input = undefined,
	inputLabel = undefined,
	inputValidator = undefined,
	inputPlaceholder = undefined,
	inputAttributes = undefined,
	customClass = {
		confirmButton: undefined,
		cancelButton: undefined,
	},
	onOpen,
}) =>
	Swal.fire({
		title,
		html: text,
		footer,
		icon,
		iconHtml,
		imageUrl: imageIcon === "trash" ? "/images/TrashCircle.svg" : imageIcon === "success" ? "/images/SuccessCircle.svg" : imageIcon === "error" ? "/images/TimesCircle.svg" : imageIcon === "warning" ? "/images/WarningCircle.svg" : imageIcon === "like" ? "/images/LikeIcon.svg" : null,
		imageWidth: 80,
		imageHeight: 80,
		imageAlt: imageIcon,
		showCancelButton,
		cancelButtonColor,
		cancelButtonText,
		showConfirmButton,
		confirmButtonColor,
		confirmButtonText,
		showCloseButton,
		timer,
		timerProgressBar: Boolean(timer),
		allowOutsideClick,
		allowEscapeKey,
		reverseButtons,
		input,
		inputLabel,
		inputValidator,
		inputPlaceholder,
		inputAttributes,
		customClass: {
			...customClass,
			confirmButton: `btn btn-primary btn-large ${customClass.confirmButton}`,
			cancelButton: `btn btn-secondary btn-large ${customClass.cancelButton}`,
		},
		focusConfirm: false,
		onOpen,
	}).then((result) => {
		if (result.isConfirmed && onConfirm) {
			onConfirm(result.value);
		} else if (result.isDismissed && onCancel) {
			onCancel();
		}
	});

export default SwAlert;
